import { useRouter } from 'next/router';
import Dialog from '../../../Dialog';
import theme from '../../../theme';
import { __t } from '../../../i18n';
import { Button, Text } from '../../../styles';
import { useEffect, useState } from 'react';
import { VideoContentData } from '../PlayerModels';
import UsePlayerProps from '../../../Store/usePlayerProps';
import { ErrorBox } from '../styles';
import { VideoErrorReportRequest, sendVideoErrorDiagnostic } from 'common/apiService';
import AlertService from 'common/AlertService';
import { VideoJsPlayer } from 'video.js';
import { getDeviceInfo } from 'common/utils';
import lscache from 'lscache';

// const showSimplePlayer = (userAgent: string) => {
//   const versionReg = /\bOpera\b|Bravia\b|Sony\b/gi;
//   return versionReg.test(userAgent);
// };

const ErrorModal = ({ player, isLive, isShort } : {player: VideoJsPlayer; isLive: boolean; isShort: boolean }) => {
  const playerGlobalState = UsePlayerProps((state) => state.playerState);
  const { contentUrl } = playerGlobalState.contentData as VideoContentData;
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(false);
  const [hideReportBtn, setHideReportBtn] = useState(false);

  useEffect(() => {
    handleMobileBreakpoint();
    window.addEventListener('resize', handleMobileBreakpoint);
    return () => {
      window.removeEventListener('resize', handleMobileBreakpoint);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMobileBreakpoint = () => {
    setIsMobile(Number(theme.breakpoints.md) > Number(window.innerWidth));
  };

  const handleSendErrorDiagnosis = async () => {
    if (!player) return;
    const deviceInfo = getDeviceInfo();
    const video = player?.options_.sources[0];
    const error = player.error() ? player.error() : {};
    const tech = player?.tech(true);
    const vhs = tech?.vhs || tech?.hls;
    const stats = vhs?.stats;
    const bandwidth = vhs?.bandwidth || stats?.bandwidth;

    const playerErrorData = {
      bandwidth,
      error,
      stats,
    };

    const feedbackData: VideoErrorReportRequest = {
      brand: deviceInfo?.brand,
      model: deviceInfo?.model,
      app_version: deviceInfo?.app_version,
      os_version: deviceInfo?.os_version,
      screen_width: deviceInfo?.screen_width,
      screen_height: deviceInfo?.screen_height,
      related_content_id: video.id,
      related_file_id: video.id,
      video_url: video.src,
      video_type: 'hls',
      raw_data: JSON.stringify(playerErrorData),
    };

    await sendVideoErrorDiagnostic(feedbackData)
      .then(() => {
        setHideReportBtn(true);
        AlertService.success(__t('comments.feedback.success'));
        switchPlayer();
      });
  };

  const switchPlayer = () => {
    if (!isLive) lscache.set('player_config', { ...lscache.get('player_config'), tech: 'mp4' });
    router.reload();
  };

  const handleBack = () => {
    if (isLive) {
      router.replace('/live');
    } else if (isShort) {
      router.back();
    } else {
      router.replace(contentUrl);
    }
  };

  return (
    <>
      <Dialog open={true} backColor={theme.palette.background[700][0]} customWidth={isMobile ? '320px' : '432px'} radius="1.5rem"
        hasWidth={true}>
        <ErrorBox direction="column" justify="center" align="center">
          <Text variant="h2" as="div" mb="1.5rem">{__t('player.play_err_title')}</Text>
          <Text variant="body1" as="div">{__t('player.play_err')}</Text>
          {/* {(!isLive && (decodeErr || showSimplePlayer(navigator.userAgent))) &&*/}
          {/*  <Button fullWidth variant="success" mt={isMobile ? '1rem' : '2rem'} onClick={() => {*/}
          {/*    lscache.set('player_config', { ...lscache.get('player_config'), tech: 'mp4' });*/}
          {/*    window.location.reload();*/}
          {/*  }}>*/}
          {/*    {__t('player.simple_player')}*/}
          {/*  </Button>*/}
          {/* }*/}
          <Button fullWidth variant="secondary" mt={isMobile ? '1rem' : '2rem'} onClick={switchPlayer}>
            {__t('player.retry')}
          </Button>
          {!hideReportBtn && !isLive && <Button
            fullWidth variant="warning" mt={isMobile ? '1rem' : '2rem'} onClick={handleSendErrorDiagnosis}>
            {__t('player.send.feedback')}
          </Button>}
          <Button fullWidth variant="flat" mt={isMobile ? '0.5rem' : '1rem'} onClick={handleBack}>
            {__t('player.back')}
          </Button>
        </ErrorBox>
      </Dialog>
    </>
  );
};

export default ErrorModal;
